import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../utils/Utils"

class SezioneDodici extends Component {

    state = {
        sezioneDodici: {
            encefalopatia: "",
            fulminante: "",
            trapiantoFegato: "",
            decesso: "",
            dataDecesso: "",
            causaIniziale: "",
            corretto: []
        }

    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneDodici) {
            let sezioneDodici = this.state.sezioneDodici
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneDodici))
            sezioneDodici.encefalopatia = propsSezione.encefalopatia ? propsSezione.encefalopatia : ""
            sezioneDodici.fulminante = propsSezione.fulminante ? propsSezione.fulminante : ""
            sezioneDodici.trapiantoFegato = propsSezione.trapiantoFegato ? propsSezione.trapiantoFegato : ""
            sezioneDodici.decesso = propsSezione.decesso ? propsSezione.decesso : ""
            sezioneDodici.dataDecesso = propsSezione.dataDecesso ? propsSezione.dataDecesso : ""
            sezioneDodici.causaIniziale = propsSezione.causaIniziale ? propsSezione.causaIniziale : ""
            this.setState({sezioneDodici: sezioneDodici})
        }
        this.controllaDati()
        this.props.setSezioneDodici(this.state.sezioneDodici)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneDodici(this.state.sezioneDodici, this.validate(), res)
        }
    }


    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneDodici))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneDodici
        dati.corretto = []

        if (dati.decesso === "01" && dati.causaIniziale === "") dati.corretto[0] = "Campo \"Causa iniziale\" mancante";
        if (dati.decesso === "01" && (!dati.dataDecesso || (!dati.dataDecesso || (dati.dataDecesso && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataDecesso), "-"))))) dati.corretto[1] = "Campo \"in caso di decesso, indicare la data\" mancante";

    }


    riceviValoreRadioButton(event, field) {
        let sezioneDodici = this.state.sezioneDodici
        sezioneDodici[field] = event

        this.setState({sezioneDodici: sezioneDodici})
    }

    riceviValoreInput(field, event) {

        let sezioneDodici = this.state.sezioneDodici
        if (field.currentTarget) {
            sezioneDodici[field.currentTarget.id] = field.currentTarget.value
        } else {
            sezioneDodici[field] = event.target.value
        }
        this.setState({sezioneDodici: sezioneDodici})
    }

    validate() {

        if (this.state.sezioneDodici.dataDecesso) {
            let validatedataDecesso = Utils.checkDateInterval(this.state.sezioneDodici.dataDecesso, "31/12/1899");
            let validatedataDecessoOdierna = Utils.checkDateInterval(this.state.sezioneDodici.dataDecesso, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDecesso) {
                return "Messages.DataDecesso"
            } else if (!validatedataDecessoOdierna) {
                return "Messages.DataDecessoOdierna"
            }
        }

        if (this.state.sezioneDodici.decesso !== "01") {
            if (this.state.sezioneDodici.dataDecesso) return "Messages.ERR_01_02_0D_BD"
            else if (this.state.sezioneDodici.causaIniziale) return "Messages.ERR_01_02_0D_BE"
        }

        return ""

    }

    render() {

        const {t} = this.props;

        const sezioneDodici = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 12</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.encefalopatia")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"encefalopatiaSi"}
                                             name={"encefalopatia"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "encefalopatia")}
                                             checked={this.state.sezioneDodici.encefalopatia === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"encefalopatiaNo"}
    name={"encefalopatia"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "encefalopatia")}
    checked={this.state.sezioneDodici.encefalopatia === "02"}
    />
                                <RadioButton id={"encefalopatiaNonSo"}
    name={"encefalopatia"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "encefalopatia")}
    checked={this.state.sezioneDodici.encefalopatia === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.fulminante")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"fulminanteSi"}
                                             name={"fulminante"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "fulminante")}
                                             checked={this.state.sezioneDodici.fulminante === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"fulminanteNo"}
    name={"fulminante"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "fulminante")}
    checked={this.state.sezioneDodici.fulminante === "02"}
    />
                                <RadioButton id={"fulminanteNonSo"}
    name={"fulminante"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "fulminante")}
    checked={this.state.sezioneDodici.fulminante === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.trapiantoFegato")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"trapiantoFegatoSi"}
                                             name={"trapiantoFegato"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "trapiantoFegato")}
                                             checked={this.state.sezioneDodici.trapiantoFegato === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"trapiantoFegatoNo"}
    name={"trapiantoFegato"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "trapiantoFegato")}
    checked={this.state.sezioneDodici.trapiantoFegato === "02"}
    />
                                <RadioButton id={"trapiantoFegatoNonSo"}
    name={"trapiantoFegato"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "trapiantoFegato")}
    checked={this.state.sezioneDodici.trapiantoFegato === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.decesso")}</b>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"decessoSi"}
                                             name={"decesso"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "decesso")}
                                             checked={this.state.sezioneDodici.decesso === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"decessoNo"}
    name={"decesso"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "decesso")}
    checked={this.state.sezioneDodici.decesso === "02"}
    />
                                <RadioButton id={"decessoNonSo"}
    name={"decesso"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "decesso")}
    checked={this.state.sezioneDodici.decesso === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.dataDecesso")}</b>
                                {(this.state.sezioneDodici.decesso === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            <Calendar
                                id={"dataDecesso"}
                                onChange={this.riceviValoreInput}
                                field={"dataDecesso"}
                                value={this.state.sezioneDodici.dataDecesso}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneDodici.dataDecesso === "" ||
                                    this.state.sezioneDodici.dataDecesso == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneDodici.dataDecesso), "-")}>
                            </Calendar>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione12.domandaSei")}</b>
                                {(this.state.sezioneDodici.decesso === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Input
                                id={"causaIniziale"}
                                onChange={this.riceviValoreInput}
                                field={"causaIniziale"}
                                value={this.state.sezioneDodici.causaIniziale}
                                placeholder={"Causa iniziale"}
                            >
                            </Input>

                        </div>
                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneDodici}
        </div>
    }


}

export default withTranslation('common')(SezioneDodici)
